<template>
  <form ref="form" action="/suche" method="post" id="vue-search" name="vuesearch" @submit="submit">
    <input name="searchObj" id="searchObj" type="hidden" v-model="searchObjectAsString"/>
    <input type="hidden"
           name="tx_mediathek_search[search][needle]"
           v-model="searchObj.Needle"/>
    <input type="hidden"
           name="tx_mediathek_search[search][combinedRegion]"
           v-model="searchObj.combinedRegion"/>
    <input type="hidden"
           name="tx_mediathek_search[search][searchTags]"
           v-model="searchObjectJoinedTags"/>
    <input type="hidden"
           name="tx_mediathek_search[search][type]"
           v-model="searchObjectJoinedTypes"/>
    <input type="hidden"
           name="tx_mediathek_search[search][limit]"
           v-model="searchObj.Limit"/>
    <div id="search" class="container">
      <h2>Wonach suchen Sie?</h2>
      <needle/>
      <div class="row col-12">
        <button type="submit" class="btn btn-success">Suche starten</button>
      </div>
    </div>
  </form>
</template>

<script>
import SearchObject from '../SearchObject';
import Needle from "./Needle.vue";

export default {
  name: 'SearchForm',
  data() {
    return {
      searchObj: new SearchObject()
    }
  },
  computed: {
    searchObjectAsString () {
      return this.searchObj.toString();
    },
    searchObjectJoinedTags () {
      return this.searchObj.SearchTags.join(',');
    },
    searchObjectJoinedTypes () {
      return this.searchObj.Type.join(',');
    }
  },
  components: {
    Needle
  },
  methods: {
    submit() {
      this.$parent.$parent.$data.showOverlay = true;
    }
  }
}
</script>

<style lang="scss">
</style>